import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Lock } from "lucide-react";

/** Tasteful locked/preview state for a Pro Plus-only panel. Keeps the card in
 *  the same place on the Free Pro dashboard so the layout matches Pro Plus —
 *  explains the benefit in context instead of shouting an upgrade ad. */
export default function ProPlusLocked({ title, benefit, Icon = Lock, preview, testId }) {
  const navigate = useNavigate();
  const [paused, setPaused] = useState(null);

  useEffect(() => {
    api.get("/config/public")
      .then(r => setPaused(r.data.pro_plus_program?.enrollment_enabled === false))
      .catch(() => {});
  }, []);

  return (
    <div
      className="relative overflow-hidden rounded-2xl border border-dashed border-black/12 bg-[#FBFAF7] p-5 sm:p-6"
      data-testid={testId || "pro-plus-locked"}
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-full bg-white border border-black/8 grid place-items-center shrink-0">
          <Icon size={16} className="text-[#2D2926]/45"/>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <h4 className="font-bold text-[15px]" style={{ fontFamily: "Outfit" }}>{title}</h4>
            <span className="text-[10px] uppercase tracking-wider font-bold px-2 py-0.5 rounded-full bg-black/[0.06] text-[#2D2926]/55 flex items-center gap-1">
              <Lock size={9}/> Available with Pro Plus
            </span>
          </div>
          <p className="text-sm text-[#2D2926]/60 mt-1">{benefit}</p>

          {preview && (
            <div className="mt-4 select-none pointer-events-none opacity-45 blur-[1.5px]" aria-hidden="true">
              {preview}
            </div>
          )}

          <button
            onClick={() => navigate("/upgrade")}
            className="mt-4 text-xs font-semibold text-[#245544] hover:underline"
            data-testid={`${testId || "pro-plus-locked"}-cta`}
          >
            {paused ? "Pro Plus is coming soon — see what's included →" : "See it with Pro Plus →"}
          </button>
        </div>
      </div>
    </div>
  );
}
